export const enTranslations = {
  header: {
    home: 'Home',
    tattooDesign: 'Tattoo Design',
    nailDesign: 'Nail Design',
    gallery: 'Gallery',
    about: 'About',
    signIn: 'Sign In',
    signOut: 'Sign Out',
    profile: 'Profile'
  },
  hero: {
    tattooSlide: {
      title: 'AI-Powered Tattoo Designs',
      description: 'Create unique tattoo designs in seconds with our advanced AI technology'
    },
    nailSlide: {
      title: 'Stunning Nail Art',
      description: 'Generate beautiful nail art designs personalized to your style'
    },
    tryNow: 'Try Now',
    viewGallery: 'View Gallery'
  },
  home: {
    features: {
      title: 'Unleash Your Creativity with AI',
      subtitle: 'Generate unique tattoo and nail designs in seconds with our advanced AI technology',
      aiPowered: {
        title: 'AI-Powered Design',
        description: 'Our cutting-edge AI analyzes thousands of professional designs to generate unique, personalized artwork for tattoos and nail art.'
      },
      unlimitedStyles: {
        title: 'Unlimited Styles',
        description: 'From minimalist line art to vibrant watercolors, create designs in any style you can imagine for both tattoos and nail art.'
      },
      completelyFree: {
        title: 'Completely Free',
        description: 'Generate as many designs as you want without any cost. Our platform is supported by non-intrusive advertisements.'
      }
    },
    featuredDesigns: {
      title: 'Featured Designs',
      viewAll: 'View all designs →'
    },
    cta: {
      title: 'Ready to Create Your Dream Design?',
      subtitle: 'Start generating unique tattoo and nail art designs in seconds with our AI technology.',
      createTattoo: 'Create Tattoo Design',
      createNail: 'Create Nail Design'
    }
  },
  tattoo: {
    title: 'Create Your Perfect Tattoo Design',
    subtitle: 'Use our AI to generate unique, personalized tattoo designs in seconds',
    generator: {
      title: 'Create Your Tattoo Design',
      describePrompt: 'Describe your dream tattoo design',
      placeholder: 'E.g., A minimalist geometric wolf tattoo with watercolor splashes in blue and purple...',
      styleOptions: 'Tattoo Style',
      colorOptions: 'Color Options',
      bodyPartOptions: 'Body Placement',
      styleDescription: 'Traditional, minimalist, watercolor, tribal, geometric...',
      uploadReference: 'Upload Reference',
      uploadDescription: 'Add a reference image to guide the AI',
      generate: 'Generate Designs',
      generating: 'Generating...',
      advancedOptions: 'Advanced Options',
      recentDesigns: 'Recent Designs',
      design: 'Design #',
      languageTip: 'For best results, use English when describing your tattoo. The AI model works better with English prompts.'
    },
    noDesignsYet: {
      title: 'No tattoo designs yet',
      description: 'Enter a description above and click "Generate Designs" to create your custom tattoo design.'
    },
    styles: {
      title: 'Popular Tattoo Styles',
      traditional: '• Traditional/Old School - Bold lines and vibrant colors',
      minimalist: '• Minimalist - Clean, simple designs with fine lines',
      geometric: '• Geometric - Patterns and shapes with mathematical precision',
      watercolor: '• Watercolor - Vibrant, flowing designs resembling watercolor painting',
      blackwork: '• Blackwork - Bold black ink designs with strong contrast',
      tribal: '• Tribal - Ancient patterns inspired by indigenous cultures'
    },
    tips: {
      title: 'Getting the Perfect Design',
      specific: {
        title: 'Be specific',
        description: 'Include style, elements, colors, and size in your description'
      },
      references: {
        title: 'Upload references',
        description: 'Provide images that inspire you for more accurate results'
      },
      variations: {
        title: 'Try variations',
        description: 'Generate multiple designs with slight prompt changes'
      },
      consult: {
        title: 'Consult with an artist',
        description: 'Always have a professional tattoo artist review your design'
      }
    }
  },
  nail: {
    title: 'Create Stunning Nail Art Designs',
    subtitle: 'Use our AI to generate beautiful, trendy nail designs in seconds',
    generator: {
      title: 'Create Your Nail Art Design',
      describePrompt: 'Describe your dream nail art design',
      placeholder: 'E.g., Galaxy-themed nail design with stars and purple to blue gradient...',
      styleOptions: 'Style Options',
      colorOptions: 'Color Options',
      bodyPartOptions: 'Body Placement',
      styleDescription: 'French, ombre, gel, acrylic, matte, glossy...',
      uploadReference: 'Upload Reference',
      uploadDescription: 'Add a reference image to guide the AI',
      generate: 'Generate Designs',
      generating: 'Generating...',
      advancedOptions: 'Advanced Options',
      recentDesigns: 'Recent Designs',
      design: 'Design #',
      languageTip: 'For best results, use English when describing your nail design. The AI model works better with English prompts.'
    },
    noDesignsYet: {
      title: 'No nail designs yet',
      description: 'Enter a description above and click "Generate Designs" to create your custom nail art design.'
    },
    styles: {
      title: 'Popular Nail Art Styles',
      french: '• French Tips - Classic white tips with a natural base',
      ombre: '• Ombre - Gradient effect from one color to another',
      gel: '• Gel - Glossy, long-lasting designs with gel polish',
      threeD: '• 3D Art - Textured designs with added elements',
      minimalist: '• Minimalist - Simple, clean designs with fine lines',
      rhinestone: '• Rhinestone - Sparkly designs with crystal accents'
    },
    tips: {
      title: 'Nail Art Tips',
      shape: {
        title: 'Consider nail shape',
        description: 'Different designs work better on square, oval, almond, or stiletto nails'
      },
      color: {
        title: 'Color harmony',
        description: 'Choose colors that complement your skin tone and wardrobe'
      },
      seasonal: {
        title: 'Seasonal trends',
        description: 'Consider current trends and seasonal colors for timely designs'
      },
      professional: {
        title: 'Professional application',
        description: 'For complex designs, consider having a nail technician apply them'
      }
    }
  },
  gallery: {
    title: 'Design Gallery',
    subtitle: 'Explore our collection of AI-generated tattoo and nail art designs',
    search: 'Search designs...',
    filters: {
      all: 'All',
      tattoos: 'Tattoos',
      nailArt: 'Nail Art'
    },
    noResults: {
      title: 'No designs found',
      subtitle: 'Try adjusting your search or filters'
    }
  },
  about: {
    title: 'About TattooNailGenius',
    subtitle: 'Revolutionizing tattoo and nail art design with AI technology',
    mission: {
      title: 'Our Mission',
      paragraph1: 'At TattooNailGenius, we\'re on a mission to democratize art design by making custom tattoo and nail art accessible to everyone. We believe that personal expression through body art should be available to all, regardless of artistic ability or budget constraints.',
      paragraph2: 'By harnessing the power of artificial intelligence, we\'ve created a platform that bridges the gap between imagination and visualization, helping people bring their creative ideas to life before making permanent decisions about their body art.'
    },
    values: {
      title: 'Our Values',
      creativity: {
        title: 'Creativity',
        description: 'We believe in empowering creativity and self-expression through innovative technology, helping users visualize their ideas in stunning detail.'
      },
      innovation: {
        title: 'Innovation',
        description: 'We continuously push the boundaries of AI technology to create more realistic, diverse, and personalized design options for our users.'
      },
      accessibility: {
        title: 'Accessibility',
        description: 'We believe everyone should have access to quality design tools without financial barriers, which is why our platform is free and supported by non-intrusive advertisements.'
      },
      community: {
        title: 'Community',
        description: 'We foster a supportive community where artists, enthusiasts, and clients can connect, share designs, and provide feedback to one another.'
      }
    },
    howItWorks: {
      title: 'How It Works',
      step1: {
        title: 'Describe Your Vision',
        description: 'Enter a detailed description of your desired tattoo or nail design. Include style preferences, themes, colors, and any specific elements you want to see.'
      },
      step2: {
        title: 'AI Generation',
        description: 'Our advanced AI processes your description and creates multiple unique design options based on your specifications, drawing inspiration from thousands of professional designs.'
      },
      step3: {
        title: 'Refine & Perfect',
        description: 'Browse the generated designs and refine them by adjusting your description or adding more details until you find the perfect match for your vision.'
      },
      step4: {
        title: 'Download & Share',
        description: 'Download your favorite designs to take to your tattoo artist or nail technician, or share them on social media to get feedback from friends and our community.'
      }
    },
    contact: {
      title: 'Get In Touch',
      subtitle: 'Have questions, feedback, or partnership inquiries? We\'d love to hear from you.',
      info: {
        title: 'Contact Information',
        email: 'Email:',
        support: 'Support:',
        business: 'Business:'
      },
      artists: {
        title: 'For Artists & Salons',
        description: 'Are you a tattoo artist or nail salon interested in partnering with TattooNailGenius? We offer special programs for professionals.',
        cta: 'Learn More'
      }
    }
  },
  designCard: {
    download: 'Download design',
    share: 'Share design'
  },
  footer: {
    description: 'Revolutionizing tattoo and nail art with AI-powered design generation.',
    navigation: 'Navigation',
    legal: 'Legal',
    termsOfService: 'Terms of Service',
    privacyPolicy: 'Privacy Policy',
    cookiePolicy: 'Cookie Policy',
    copyright: 'Copyright',
    contact: 'Contact',
    email: 'Email: info@mramoreno.tech',
    support: 'Support: info@mramoreno.tech',
    partnerships: 'Partnerships: info@mramoreno.tech',
    copyright2025: '© 2025 TattooNailGenius. All rights reserved.',
    terms: 'Terms',
    privacy: 'Privacy',
    cookies: 'Cookies'
  },
  adBanner: {
    title: 'Advertisement Space',
    subtitle: 'Your ad could be here'
  },
  auth: {
    signIn: 'Sign In',
    signUp: 'Sign Up',
    welcomeBack: 'Welcome Back',
    createAccount: 'Create an Account',
    signInSubtitle: 'Sign in to access your saved designs and profile',
    signUpSubtitle: 'Join our community to save and share your AI-generated designs',
    email: 'Email',
    password: 'Password',
    confirmPassword: 'Confirm Password',
    forgotPassword: 'Forgot Password?',
    signingIn: 'Signing In...',
    signingUp: 'Signing Up...',
    passwordsDoNotMatch: 'Passwords do not match',
    signUpSuccess: 'Account Created Successfully',
    checkEmail: 'Please check your email to verify your account.'
  },
  profile: {
    title: 'Your Profile',
    personalInfo: 'Personal Information',
    email: 'Email',
    username: 'Username',
    emailCannotBeChanged: 'Email address cannot be changed',
    updateProfile: 'Update Profile',
    updating: 'Updating...',
    updateSuccess: 'Profile updated successfully',
    favoriteDesigns: 'Favorite Designs',
    yourDesigns: 'Your Designs',
    noFavorites: 'You haven\'t saved any designs yet',
    noDesigns: 'You haven\'t created any designs yet',
    browseGallery: 'Browse the gallery and click the heart icon to save designs you like',
    createSome: 'Try creating some designs using our AI generator'
  }
};